module.exports = __webpack_public_path__ + "media/recipes/48-ad1b5b19.png";